module.exports = __webpack_public_path__ + "img/samanthaBlack.1a02e0ad.png";